import React from 'react';
import Layout from '../../scaffolding/Layout';

const FullTest = () => {
  return <Layout>Full Test</Layout>;
};

export default FullTest;
